<script>
export default {
  name: 'DarkMode',
};
</script>

<template>
  <div>
    <img class="icon-DarkMode button-box-default" src="../../../images/toggle-on-solid.svg" alt=" iconUser" />
  </div>
</template>

<style scoped>
.icon-DarkMode {
  width: 40px;
  height: 25px;
}
</style>


// WEBPACK FOOTER //
// src/components/Buttons/DarkMode/index.vue